import React, { useEffect, useRef } from 'react'

import { getTextColorFromBackgroundColor } from 'utils/theme'
import { ThemeColor } from 'utils/themes/types'

import { StyledButtonContent } from './styled'
import { ButtonProps } from './types'

import { LoadingSpinner } from '../LoadingSpinner'
import { Pressable } from '../Pressable'
import { Text } from '../Text'

const ButtonBody = ({ children, fontWeight, title, textColor, size }: any) => {
  if (children) return children

  return (
    <Text
      // Prevents double click on text
      selectable={false}
      fontSize={size}
      fontWeight={fontWeight}
      align='center'
      color={textColor}
    >
      {title}
    </Text>
  )
}

export const Button = ({
  border,
  borderRadius,
  children,
  disabled = false,
  disabledType = 'greyLight',
  fontWeight = 'semiBold',
  fullWidth = true,
  padding = { horizontal: 'md', vertical: 'md' },
  size = 'md',
  subtle = false,
  style,
  title,
  type = 'primary',
  titleColor = undefined,
  isLoading = false,
  ...props
}: ButtonProps) => {
  const textColor = useRef<ThemeColor>(
    titleColor ||
      (disabled
        ? getTextColorFromBackgroundColor(disabledType)
        : getTextColorFromBackgroundColor(type, subtle)),
  )

  useEffect(() => {
    textColor.current =
      titleColor ||
      (disabled
        ? getTextColorFromBackgroundColor(disabledType)
        : getTextColorFromBackgroundColor(type, subtle))
  }, [disabled, disabledType, subtle, titleColor, type])

  return (
    <Pressable style={style} disabled={isLoading || disabled} {...props}>
      <StyledButtonContent
        borderRadius={borderRadius}
        border={border}
        disabled={disabled}
        disabledType={disabledType}
        fullWidth={fullWidth}
        padding={padding}
        type={type}
      >
        {!isLoading ? (
          <ButtonBody
            fontWeight={fontWeight}
            size={size}
            textColor={textColor.current}
            title={title}
          >
            {children}
          </ButtonBody>
        ) : (
          <LoadingSpinner size='small' color={textColor.current} />
        )}
      </StyledButtonContent>
    </Pressable>
  )
}
